import React from 'react';
import Async from 'react-select/async';
import { recruiterStore } from '../../../settings/recruiters/RecruiterStore';

export class RecruitersDropdown extends React.Component {
	state = {
		value: null,
		loaded: false
	};
	async componentDidMount() {
		if (this.props.value) {
			this.setState({ value: this.props.value });
		}
		this.setState({ loaded: true });
	}

	render() {
		if (this.state.loaded) {
			return (
				<Async
					menuPosition={'fixed'}
					maxMenuHeight="300"
					className={
						'react-select ' +
						(this.props.styleVersion ? this.props.styleVersion : '')
					}
					cacheOptions
					value={this.state.value}
					placeholder="Recruiters"
					defaultOptions
					loadOptions={this.loadOptions}
					getOptionValue={this.getOptionValue}
					getOptionLabel={this.getOptionLabel}
					noOptionsMessage={this.noOptionsMessage}
					onChange={item => {
						if (this.props.onValueChange) {
							this.props.onValueChange(item);
						}
						this.setState({ value: item });
					}}
				/>
			);
		} else {
			return null;
		}
	}

	loadOptions = inputValue => {
		return new Promise(resolve => {
			resolve(this.getTags(inputValue));
		});
	};

	getTags = async inputValue => {
		inputValue = inputValue.replace(/\W/g, '');
		const result = await recruiterStore.getRecruiters({
			query: inputValue,
			status: 'active'
		});
		return result.data;
	};

	noOptionsMessage = value => {
		if (value.inputValue && value.inputValue.length >= 1) {
			return 'No matches found';
		} else {
			return 'Enter text to search tags';
		}
	};

	getOptionValue = option => option.id;

	getOptionLabel = option => `${option.name}`;
}
